import { Component, createContext } from "react";
import ReactDOM from "react-dom";

import { getDisplayName } from "../Utils/getDisplayName";
import { Consumer as AppContainerConsumer } from "../Main/AppContainerContext";
import CommentFormManager from "../Comments/CommentFormManager";

const { Provider, Consumer } = createContext(null);

class CommentFormServiceBase extends Component {
  static displayName = "CommentFormService";

  constructor(props) {
    super(props);
    this.showCommentForm = this.showCommentForm.bind(this);
    this.onCommentFormHidden = this.onCommentFormHidden.bind(this);

    this.state = { isFormShown: false, commentable: null };
  }

  get providedContext() {
    return {
      showCommentForm: this.showCommentForm,
      isFormShown: this.state.isFormShown
    };
  }

  get commentForm() {
    const { isFormShown, commentableId } = this.state;

    if (!isFormShown) return null;

    return ReactDOM.createPortal(
      <CommentFormManager
        commentableId={commentableId}
        onClose={this.onCommentFormHidden}
      />,
      this.props.appContainer
    );
  }

  showCommentForm(commentableId) {
    this.setState({ isFormShown: true, commentableId });
  }

  onCommentFormHidden() {
    this.setState({ isFormShown: false, commentableId: null });
  }

  render() {
    return (
      <Provider value={this.providedContext}>
        {this.props.children}
        {this.commentForm}
      </Provider>
    );
  }
}

export function CommentFormService(props) {
  return (
    <AppContainerConsumer>
      {appContainer => <CommentFormServiceBase {...props} appContainer={appContainer} />}
    </AppContainerConsumer>
  );
}

export function withCommentForm(WrappedComponent) {
  const WithCommentForm = props => {
    const { commentableId } = props;

    return (
      <Consumer>
        {({ showCommentForm, isFormShown }) => {
          const componentProps = {
            ...props,
            isFormShown,
            showCommentForm: () => {
              showCommentForm(commentableId);
            }
          };

          return <WrappedComponent {...componentProps} />;
        }}
      </Consumer>
    );
  };

  WithCommentForm.displayName = `WithCommentForm(${getDisplayName(WrappedComponent)})`;

  return WithCommentForm;
}
